import $ from 'jquery';
import { isDataExclusion } from '../adjustment-type';
import { getColumnsAndColumnChooserConfig } from './columns';

export class SeasonalityAdjustmentGridConfig {
  constructor({
    gridName, i18n, dataSource, scope, columnChooserPreferences, preferenceService, filterService, perfMarker, globalConfig,
    blockerTarget, inlineEditConfig, adjustmentType,
  }) {
    const { columnsConfig, columnChooserConfig } = getColumnsAndColumnChooserConfig({
      i18n, columnChooserPreferences, inlineEditConfig, scope, adjustmentType,
    });

    const pluginsConfig = {
      perfMarker: {
        appConfig: globalConfig,
        marker: perfMarker,
      },
      a11y: { i18n },
      pagination: {
        availablePageSizes: [20, 50, 100, 200],
        pageNumberLabelText: i18n.getString(_TL_('Page')),
        pageSizeText: i18n.getString(_TL_('Show rows:')),
        enableRandomPage: false,
      },
      uiBlocker: {
        el: blockerTarget,
        text: i18n.getString(_TL_('Loading...')),
      },
      placeholder: {
        container: '.grid-noresult',
        text: i18n.getString(isDataExclusion(adjustmentType) ?
          _TL_('You have no data exclusions. Click Create to get started.')
          : _TL_('You have no seasonality adjustments. Click Create to get started.')),
        filteredEmptyText: i18n.getString(_TL_('There are no results available based on your filtered search. Please revise your search.')),
      },
      columnChooser: columnChooserConfig,
      editable: {
        i18n,
      },
      projectionGridScopeNavigator: scope,
      projectionGridFlexColumnResize: {
        gridName,
        preferenceService,
      },
      projectionGridScrollbar: {
        scrollElementSelector: '.grid-group-other',
      },
    };

    const tableName = i18n.getString(isDataExclusion(adjustmentType) ? _TL_('Data exclusions') : _TL_('Seasonality Adjustment'));

    return {
      name: gridName,
      tableClasses: ['table'],
      tableAttributes: { 'aria-label': tableName },
      layout: 'flex',
      i18n,
      columns: columnsConfig,
      dataSource,
      rows: {
        headRows: [
          'column-header-rows',
        ],
      },
      selection: {
        single: true,
      },
      scrolling: {
        header: {
          type: 'sticky',
          offset: () => $('.sticky-container').height(),
          attributes: {
            'aria-label': i18n.getString(_TL_('{{tableName}} table header'), { tableName }),
            role: 'rowgroup',
          },
        },
        virtualized: true,
        // backbone-virtualized-listview listens to viewport element's resize and scroll events to refresh header's position.
        // Search keyword `_hookUpStickyHeader` to see more details.
        viewport: $('.table-page-container'),
      },
      plugins: pluginsConfig,
      // Needed by inline download plugin
      //   projection-grid-inline-download/src/without-dependencies.js line 21
      filterService,
      // Needed by pagination plugin
      //   projection-grid-pagination/src/index.es line 115
      preferenceService,
      config: globalConfig,
    };
  }
}
